import axios from "axios";

const classPrefix = 'summary-promo'
const dataPrefix = 'data-summary-promo'
const $container = document.querySelector(`[${dataPrefix}]`)
import GLightbox from 'glightbox';
import {mainSpecialistVideo} from "../main-specialist-video/main-specialist-video";
import {initNewGallery} from "../swiper/swiper";

if ($container) {
    summaryPromo({$container})
}

export function summaryPromo({$container}) {

    const $promoSwiper = $container.querySelector(`[${dataPrefix}-promo-swiper]`)
    const $loader = $container.querySelector(`[${dataPrefix}-loader]`)

    let videos = [];

    init();

    function init() {
        getVideos();
    }
    function getVideos(){
        axios({
            method: 'GET',
            url: '/api/videos',
        }).then((response) => {
            if (response.data.videos)
            {
                videos = response.data.videos
                initVideos();
            }
        }).finally(() => {
            $loader.style.display = 'none'
        });
    }

    function initVideos(){
        const swiperClass = `${classPrefix}-swiper`;

        $promoSwiper.classList.add(swiperClass);
        const $swiperWrapper = $promoSwiper.querySelector('.swiper-wrapper');

        mainSpecialistVideo($swiperWrapper, videos)
        initNewGallery(swiperClass)

    }
}




